module.exports = __webpack_public_path__ + "static/media/blacksquare1.90c10fd7.png";